var video_url, video_title,
    modalVideo = jQuery('#modalVideo');

jQuery('a.video_modal').on('click', function(e){
    e.preventDefault();
    video_url = jQuery(this).data('video');
    video_title =  jQuery(this).data('title');
    jQuery('#modalVideo video').attr('src', video_url);
    jQuery('#modalVideo .modal-title').html(video_title);
});

modalVideo.on('show.bs.modal', function () {
    document.getElementById('video-2').play();
});
modalVideo.on('hidden.bs.modal', function () {
    document.getElementById('video-2').pause();
});

